import _typeof from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find-index.js";
import { getIntervalAnalysisApi, getAllAnalysisDataApi, getAnalysisAvailabilityApi, getAvailabilityRemarkApi, updateAvailabilityRemarkApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';
import i18n from '@/lang/lang';
import Highcharts from 'highcharts';
import hcHeatmap from 'highcharts/modules/heatmap';
import { isDateAfterToday } from '@/utils/datetime';
import twJson from '@/lang/langJson/tw';

import { mapState, mapMutations, mapActions } from 'vuex';
import dayjs from 'dayjs';
import downloadCsv from 'download-csv';
hcHeatmap(Highcharts);
export default {
  name: 'DataAnalysis',
  data: function data() {
    return {
      isLoadingData: false,
      hasSearchedRemark: false,
      remarkDateRadioOptions: [{
        value: 'date',
        text: '日'
      }, {
        value: 'month',
        text: '月'
      }],
      remarkTimeOptions: [{
        value: null,
        text: ''
      }].concat(_toConsumableArray(Array(24)).map(function (_item, idx) {
        var option = String(idx).padStart(2, '0') + ':00';
        return {
          value: option,
          text: option
        };
      })),
      remarkData: [
        // { radio: 'year', date: 2023, time: 02:00, remark: 'xxx', isEditing: false },
      ],
      tableFields: [{
        key: 'edit',
        label: '編輯'
      }, {
        key: 'date',
        label: '日期'
      }, {
        key: 'time',
        label: '時間'
      }, {
        key: 'remark',
        label: '備註'
      }],
      dataAnalysisResError: false,
      // totalSumArray: {},
      isInvAllSelected: false,
      isAnemometerAllSelected: false,
      hasChangeActivePageIdx: false,
      selectedChartLegends: ['發電時數 (h)', '發電量 (kWh)', '投資收入 (NTD)'],
      chartLegendOptions: [],
      activePageIdx: 0,
      analysisPages: Object.keys(twJson.dataAnalysis.page),
      dateCateActive: '日',
      datePickerFormat: 'YYYY-MM',
      dateRangePickerFormat: 'YYYY-MM-DD',
      invSelections: ['INV01', 'INV02', 'INV03', 'INV04', 'INV05', 'INV06', 'INV07', 'INV08'],
      selectedInvs: [],
      anemometerSelections: ['風速計01', '風速計02'],
      selectedAnemometers: [],
      selectedDate: new Date(),
      selectedStartDate: new Date(),
      selectedEndDate: new Date(),
      hasSelectedInterval: false,
      queryDateArr: [],
      analysisAllData: [],
      dataAnalysisChart: {
        chart: {
          height: 350,
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        title: {
          text: '發電統計與發電收入圖: 2022-03-03'
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        yAxis: [{
          title: {
            text: 'sss'
          }
        }, {
          title: {
            text: 'aaa'
          },
          opposite: true
        }, {
          title: {
            text: 'bbbb'
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        series: [],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      heatmapChart: {
        chart: {
          type: 'heatmap',
          // marginLeft: 300,
          // marginRight: 300,
          // marginBottom: 20,
          plotBorderWidth: 1,
          height: 380
          // spacing: [50, 50, 50, 50]
        },
        credits: {
          enabled: false
        },
        title: {
          text: '峰瓩值'
        },
        xAxis: {
          categories: [
            // 時間
          ],
          tickWidth: 1,
          tickInterval: 4
          // tickPositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48],
          // startOnTick: true,
          // endOnTick: true
        },
        yAxis: {
          categories: [
            // INV 台數
          ],
          title: null,
          // startOnTick: false,
          endOnTick: false
        },
        // 圖例設定
        colorAxis: {
          min: 0,
          max: 0.25,
          // tickInterval: 0.05,
          // minColor: '#FFFFFF',
          // maxColor: Highcharts.getOptions().colors[0],
          stops: [[0, '#1e48aa'],
          // [0.1, '#2399cc'],
          [0.25, '#2faeda'],
          // [0.3, '#99da98'],
          // [0.4, '#dcff7a'],
          [0.5, '#fcf474'],
          // [0.6, '#ffea6d'],
          [0.75, '#f77543'],
          // [0.8, '#ff8c52'],
          // [0.9, '#ff6e4e'],
          [1, '#c4463a']],
          // startOnTick: true,
          // endOnTick: true,
          labels: {
            format: '{value}'
          }
        },
        // 圖例
        legend: {
          title: {
            // text: 'kW/kWp<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>'
            // style: {
            //   fontStyle: 'italic'
            // }
          },
          // layout: 'vertical',
          // align: 'right',
          // margin: 20,
          // verticalAlign: 'top',
          // y: 20,
          // symbolHeight: 280
          symbolWidth: 250
        },
        tooltip: {
          formatter: function formatter() {
            return '<b>' + this.series.xAxis.categories[this.point.x] + '</b>&ensp;' + this.series.yAxis.categories[this.point.y] + '<br><b>峰瓩值: ' + this.point.value + ' (kW/kWp)</b>';
          }
        },
        series: [{
          name: 'chart title name',
          borderWidth: 0,
          data: [
            // [x 座標, y 座標, 值]
            // [0, 0, 100],
            // [0, 1, 19]
            // [1, 0, 92]
            // [1, 1, 58],
            // [2, 0, 35],
            // [2, 1, 15],
            // [3, 0, 72],
            // [3, 1, 132],
          ]
          // dataLabels: {
          //   enabled: true,
          //   color: '#000000'
          // }
        }]
      },
      // 下載的值 要存原始 raw data 的數值
      // heatMap 存的格式 [ , , ]
      // 非 heatMap 存的格式 [{ rawData: [] },{ rawData: [] }...]
      rawDataForExcel: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryData', 'capacity', 'hasDataAnalysisTimePermission', 'querySiteName', 'hasRoleAdmin'])), {}, {
    fid: function fid() {
      return this.$route.query.fid;
    },
    chartTitle: function chartTitle() {
      var key = "INVComparison".concat(this.activePageIdx);
      return i18n.t("dataAnalysis.chartTitle.".concat(key));
    },
    isHeatmapPage: function isHeatmapPage() {
      return this.activePageIdx === 6; // 峰瓩值熱圖
    },
    isAnemometerPage: function isAnemometerPage() {
      return this.activePageIdx === 10; // 風速計
    },
    isAvailabilityPage: function isAvailabilityPage() {
      return this.activePageIdx === 11; // 妥善率
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations(['changeDataAnalysisLang'])), mapActions(['asyncLastSingleDoc'])), {}, {
    isDateAfterToday: isDateAfterToday,
    handleCheckRemark: function handleCheckRemark(index) {
      var _this$remarkData$inde;
      if (!this.remarkData[index].date || !((_this$remarkData$inde = this.remarkData[index].remark) !== null && _this$remarkData$inde !== void 0 && _this$remarkData$inde.trim())) {
        return this.$swal('請輸入日期、備註文字');
      }
      this.remarkData[index].isEditing = !this.remarkData[index].isEditing;
    },
    handleChangeRemarkDateType: function handleChangeRemarkDateType(index, radioVal) {
      this.remarkData[index].radio = radioVal;
      if (radioVal === 'date') {
        this.remarkData[index].date = dayjs().format('YYYY-MM-DD');
      }
      if (radioVal === 'month') {
        this.remarkData[index].date = dayjs().format('YYYY-MM');
        this.remarkData[index].time = null;
      }
    },
    handleSelectRemarkDate: function handleSelectRemarkDate(index, key, value) {
      this.remarkData[index][key] = value;
    },
    handleSelectRemarkTime: function handleSelectRemarkTime(index, key, value) {
      this.remarkData[index][key] = value;
    },
    handleInputRemark: function handleInputRemark(index, key, value) {
      this.remarkData[index][key] = value.trim().replace(/\s+/g, ' '); // replace 多個空格變為一個
    },
    // invSum (arr) {
    //   return dbDataHandle(
    //     arr.reduce((x, y) => {
    //       return x + y
    //     })
    //   )
    // },
    // invAvg (arr) {
    //   return dbDataHandle(arr.reduce((x, y) => x + y, 0) / arr.length)
    // },
    resetSelectedList: function resetSelectedList() {
      if (this.isAnemometerPage) {
        this.selectedAnemometers = [];
      } else {
        this.selectedInvs = [];
      }
    },
    resetChartAndExcel: function resetChartAndExcel() {
      this.rawDataForExcel = [];
      this.dataAnalysisChart.series = [];
      this.dataAnalysisChart.xAxis.categories = [];
      this.heatmapChart.series[0].data = [];
      this.heatmapChart.xAxis.categories = [];
    },
    selectAnalysisPage: function selectAnalysisPage(selected) {
      var _this$remarkData;
      if (selected === this.activePageIdx) return;
      this.activePageIdx = selected;
      this.hasChangeActivePageIdx = true;

      // 使用 tooltip formatter 不能使用 shared，點選其他頁面時更改回來
      if (selected !== 11) this.dataAnalysisChart.tooltip = {
        shared: true
      };
      if (selected === 11 && !((_this$remarkData = this.remarkData) !== null && _this$remarkData !== void 0 && _this$remarkData.length)) {
        this.getAvailabilityRemark();
        this.hasSearchedRemark = true;
      }

      // 峰瓩值熱圖、風速計 清除時間選項
      if (selected === 6 || selected === 10) {
        this.hasSelectedInterval = false;
        this.dateCateActive = '時';
        this.selectedDate = new Date();
        this.datePickerFormat = 'YYYY-MM-DD';
      }

      // 若點選 風速計，則預設全選
      if (selected === 10) {
        this.isAnemometerAllSelected = true;
        this.selectedAnemometers = this.anemometerSelections;
      }
      this.confirmSearching();
    },
    selectDateCate: function selectDateCate(selected) {
      this.dateCateActive = selected;
      switch (selected) {
        case '時':
          this.datePickerFormat = 'YYYY-MM-DD';
          this.dateRangePickerFormat = 'YYYY-MM-DD';
          this.hasSelectedInterval = false;
          break;
        case '日':
          this.datePickerFormat = 'YYYY-MM';
          this.dateRangePickerFormat = 'YYYY-MM-DD';
          break;
        case '月':
          this.datePickerFormat = 'YYYY';
          this.dateRangePickerFormat = 'YYYY-MM';
          break;
      }

      // PR 值分析 切換 時/日/月，於 日/月 時 toggle 選項重整
      this.hasChangeActivePageIdx = this.activePageIdx === 4 && this.dateCateActive !== '時';
      this.confirmSearching();
    },
    confirmSearching: function confirmSearching() {
      var _this = this;
      // 無區間
      if (!this.hasSelectedInterval) {
        var dayStart = dayjs(this.selectedDate).format(this.datePickerFormat);
        this.queryDateArr = [dayStart];
        this.getAllData();
        return;
      }

      // 選擇區間
      var yearMonthStart = dayjs(this.selectedStartDate).format('YYYY-MM');
      var yearMonthEnd = dayjs(this.selectedEndDate).format('YYYY-MM');
      var howManyYears = dayjs(yearMonthEnd).diff(dayjs(yearMonthStart), 'year') + 1;
      var howManyMonths = dayjs(yearMonthEnd).diff(dayjs(yearMonthStart), 'month') + 1;

      // 區間, 跨年, '日'
      if (this.dateCateActive === '日') {
        this.queryDateArr = Array.from({
          length: howManyMonths
        }, function (_, idx) {
          return dayjs(_this.selectedStartDate).add(idx, 'month').format('YYYY-MM');
        });
      } else {
        // 區間, 跨年, '月'
        this.queryDateArr = Array.from({
          length: howManyYears
        }, function (_, idx) {
          return dayjs(_this.selectedStartDate).add(idx, 'year').format('YYYY');
        });
      }
      this.getAllData();
    },
    downloadAnalysis: function downloadAnalysis() {
      var _this2 = this;
      var downloadArr = [];
      var fields = ['name'];
      if (this.isHeatmapPage) {
        var selectedInvArr = _toConsumableArray(this.heatmapChart.yAxis.categories).reverse();

        // inv (excel column title)
        fields = fields.concat(selectedInvArr);

        // time (excel row title)
        this.heatmapChart.xAxis.categories.forEach(function (time) {
          downloadArr.push({
            name: time
          });
        });

        // 全選 (直接取用做好的圖表數據)
        if (fields[1] === 'average') {
          this.heatmapChart.yAxis.categories.forEach(function (inv) {
            downloadArr.forEach(function (item, idx) {
              item["".concat(inv)] = _this2.rawDataForExcel[idx];
            });
          });
        }

        // 有選擇 INV (從 db 拿的資料處理)
        if (fields[1] !== 'average') {
          downloadArr.forEach(function (rowItem, rowIdx) {
            // 06:00 -> foundTimeData (hhmm: 06:00)
            // 06:15 -> foundTimeData (hhmm: 06:00)
            // 07:45 -> foundTimeData (hhmm: 07:00)
            var foundTimeData = _this2.analysisAllData.filter(function (data) {
              return data.hhmm.split(':')[0] === rowItem.name.split(':')[0];
            });
            if (foundTimeData.length) {
              // 'INV02', 'INV08', 'INV11'...
              selectedInvArr.forEach(function (invName) {
                var invIndex = Number(invName.slice(3)); // 2, 8, 11...
                var insertData = foundTimeData[0].kWp[rowIdx % 4][invIndex - 1];
                // rowIdx 0 | rowItem 06:00 | kWp index 0
                // rowIdx 1 | rowItem 06:15 | kWp index 1
                // rowIdx 2 | rowItem 06:30 | kWp index 2
                // rowIdx 3 | rowItem 06:45 | kWp index 3
                // rowIdx 4 | rowItem 07:00 | kWp index 0
                // rowIdx 5 | rowItem 07:00 | kWp index 1
                // rowIdx % 4 為 kWp index

                rowItem["".concat(invName)] = insertData !== null && insertData !== void 0 ? insertData : null;
              });
            }
          });
        }
      }
      if (!this.isHeatmapPage && !this.isAvailabilityPage) {
        fields = fields.concat(this.dataAnalysisChart.xAxis.categories);
        this.dataAnalysisChart.series.forEach(function (x) {
          downloadArr.push({
            name: x.name
          });
        });
        this.dataAnalysisChart.xAxis.categories.forEach(function (x, xIndex) {
          downloadArr.forEach(function (y, yIndex) {
            y["".concat(x)] = _this2.rawDataForExcel[yIndex].rawData[xIndex];
          });
        });
      }
      if (!this.isHeatmapPage && this.isAvailabilityPage) {
        // 妥善率
        fields = fields.concat(this.dataAnalysisChart.xAxis.categories); // ['name'] + ['06:00','07:00'...]
        this.dataAnalysisChart.series.forEach(function (x) {
          downloadArr.push({
            name: x.name
          });
        });
        this.dataAnalysisChart.xAxis.categories.forEach(function (time, timeIndex) {
          downloadArr.forEach(function (y, yIndex) {
            y["".concat(time)] = _this2.rawDataForExcel[yIndex].rawData[timeIndex];
          });
        });

        // 妥善率的 tooltip 備註，也要放入資料下載
        fields.forEach(function (key, index) {
          if (index === 0) return downloadArr.push({
            name: '備註'
          });
          downloadArr[downloadArr.length - 1][key] = _this2.dataAnalysisChart.series[0].data[index - 1].remark;
        });
      }
      var fileNameArr = ['發電收入', '變流器轉換效率', '平均日照分析', '溫度分析', 'PR值分析', '峰瓩值', '峰瓩值熱圖', '二氧化碳抑低量', 'INV溫度', 'Insulation', '風速計', '妥善率'];
      var fileName = "\u8CC7\u6599\u5206\u6790_".concat(fileNameArr[this.activePageIdx]);
      downloadCsv(downloadArr, fields, fileName);
    },
    getAvailabilityRemark: function getAvailabilityRemark() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _data$data, _data$data2, _data$data2$, _yield$getAvailabilit, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getAvailabilityRemarkApi(_this3.fid);
              case 3:
                _yield$getAvailabilit = _context.sent;
                data = _yield$getAvailabilit.data;
                if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.length && (_data$data2 = data.data) !== null && _data$data2 !== void 0 && (_data$data2$ = _data$data2[0]) !== null && _data$data2$ !== void 0 && _data$data2$.length) {
                  // 有可能是 [[]]
                  _this3.remarkData = data.data.map(function (arr) {
                    var _arr$0$split, _arr$0$split$, _arr$0$split2;
                    return {
                      radio: arr[0].length > 7 ? 'date' : 'month',
                      date: (_arr$0$split = arr[0].split(' ')) === null || _arr$0$split === void 0 ? void 0 : _arr$0$split[0],
                      time: (_arr$0$split$ = (_arr$0$split2 = arr[0].split(' ')) === null || _arr$0$split2 === void 0 ? void 0 : _arr$0$split2[1]) !== null && _arr$0$split$ !== void 0 ? _arr$0$split$ : null,
                      remark: arr[1],
                      isEditing: false
                    };
                  });
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log('getAvailabilityRemark', _context.t0);
              case 11:
                _context.prev = 11;
                _this3.hasSearchedRemark = true;
                return _context.finish(11);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8, 11, 14]]);
      }))();
    },
    updateAvailabilityRemark: function updateAvailabilityRemark() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var hasEdit, remarks, _yield$updateAvailabi, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // check
                hasEdit = _this4.remarkData.map(function (obj) {
                  return obj.isEditing;
                }).includes(true);
                if (!hasEdit) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", _this4.$swal('請先確定所有編輯中的欄位'));
              case 3:
                _context2.prev = 3;
                remarks = _this4.remarkData.sort(function (a, b) {
                  var aTime = a.time ? new Date("".concat(a.date, " ").concat(a.time)) : new Date("".concat(a.date, " 23:59"));
                  var bTime = b.time ? new Date("".concat(b.date, " ").concat(b.time)) : new Date("".concat(b.date, " 23:59"));
                  return bTime - aTime;
                }).map(function (obj) {
                  if (!obj.time) return [obj.date, obj.remark];
                  return ["".concat(obj.date, " ").concat(obj.time), obj.remark];
                });
                if (!remarks.length) remarks = [[]]; // 無資料時，這樣才能存進 db
                _context2.next = 8;
                return updateAvailabilityRemarkApi(_this4.fid, remarks);
              case 8:
                _yield$updateAvailabi = _context2.sent;
                data = _yield$updateAvailabi.data;
                if (!(data !== null && data !== void 0 && data.success)) {
                  _context2.next = 16;
                  break;
                }
                _context2.next = 13;
                return _this4.getAllData();
              case 13:
                _context2.next = 15;
                return _this4.getAvailabilityRemark();
              case 15:
                _this4.$swal('更新資料成功');
              case 16:
                _context2.next = 21;
                break;
              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](3);
                console.log('updateAvailabilityRemark', _context2.t0);
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 18]]);
      }))();
    },
    getAllData: function getAllData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var responses;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.isLoadingData = true;
                _this5.analysisAllData = [];
                _context3.next = 4;
                return Promise.allSettled(_this5.queryDateArr.map(function (date) {
                  return _this5.isHeatmapPage || _this5.isAnemometerPage ? getIntervalAnalysisApi(_this5.fid, date) : _this5.isAvailabilityPage ? getAnalysisAvailabilityApi(_this5.querySiteName, _this5.fid, date) : getAllAnalysisDataApi(_this5.querySiteName, _this5.fid, date);
                }));
              case 4:
                responses = _context3.sent;
                responses.forEach(function (res) {
                  var _res$value, _res$value$data;
                  if (res !== null && res !== void 0 && (_res$value = res.value) !== null && _res$value !== void 0 && (_res$value$data = _res$value.data) !== null && _res$value$data !== void 0 && _res$value$data.success) {
                    var _this5$analysisAllDat;
                    (_this5$analysisAllDat = _this5.analysisAllData).push.apply(_this5$analysisAllDat, _toConsumableArray(res.value.data.data));
                  }
                });
                _this5.dataAnalysisResError = !_this5.analysisAllData.length;
                _this5.isLoadingData = false;
                _this5.analysisAllDataPrepare();
              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    analysisAllDataPrepare: function analysisAllDataPrepare() {
      var selectedDate = dayjs(this.selectedDate).format(this.datePickerFormat);
      var startDate = dayjs(this.selectedStartDate).format(this.dateRangePickerFormat);
      var endDate = dayjs(this.selectedEndDate).format(this.dateRangePickerFormat);
      var invArr = this.selectedInvs.length ? this.selectedInvs.map(function (x) {
        return Number(x.slice(-2));
      }).sort(function (a, b) {
        return a - b;
      }) : ['ALL'];
      if ([2, 3, 11].includes(this.activePageIdx)) {
        invArr = ['ALL'];
      }
      if (this.isAnemometerPage) {
        invArr = this.selectedAnemometers.map(function (item) {
          return Number(item.slice(-2));
        }).sort(function (a, b) {
          return a - b;
        });
      }

      // 過濾查詢區間有資料的
      if (this.hasSelectedInterval) {
        this.analysisAllData = this.analysisAllData.filter(function (x) {
          return x.hhmm >= startDate && x.hhmm <= endDate;
        });
      }
      this.resetChartAndExcel();

      // 顯示有資料的日期區間
      this.dataAnalysisChart.title.text = this.hasSelectedInterval ? "".concat(this.chartTitle, ": ").concat(this.analysisAllData[0].hhmm, " ~ ").concat(this.analysisAllData.at(-1).hhmm) : "".concat(this.chartTitle, ": ").concat(selectedDate);
      this.heatmapChart.title.text = "".concat(this.chartTitle, ": ").concat(selectedDate);
      switch (this.activePageIdx) {
        case 0:
          return this.getElectricByDays(invArr);
        case 1:
          return this.getInvTransform(invArr);
        case 2:
          return this.getAverageIrr(invArr);
        case 3:
          return this.getTemp(invArr);
        case 4:
          return this.getPR(invArr);
        case 5:
          return this.getPeakWatt(invArr);
        case 6:
          return this.getPeakWattHeatmap(invArr);
        case 7:
          return this.getCo2(invArr);
        case 8:
          return this.getInvTemp(invArr);
        case 9:
          return this.getInsulation(invArr);
        case 10:
          return this.getAnemometer(invArr);
        case 11:
          return this.getAvailability(invArr);
        default:
          break;
      }
    },
    dataAnalysisChartSeriesPrepare: function dataAnalysisChartSeriesPrepare(invArr) {
      var _this6 = this;
      // this.totalSumArray = {}
      var name = this.selectedChartLegends;
      for (var i = 0; i < name.length; i++) {
        // this.totalSumArray[name[i]] = [{}]
        for (var j = 0; j < invArr.length; j++) {
          var yIndex = name.includes('模組溫度 (°C)') || name.includes('環境溫度 (°C)') ? 0 : i;
          this.dataAnalysisChart.series.push({
            type: 'spline',
            yAxis: yIndex,
            name: this.isAnemometerPage ? "Anemometer".concat(invArr[j], "-").concat(name[i]) : "Inv".concat(invArr[j], "-").concat(name[i]),
            data: []
          });
          this.rawDataForExcel.push({
            rawData: []
          });
          // this.totalSumArray[name[i]][j] = {}
          // this.totalSumArray[name[i]][j][`Inv${invArr[j]}`] = []
        }
      }
      this.dataAnalysisChart.yAxis = [];
      if (name.includes('模組溫度 (°C)') || name.includes('環境溫度 (°C)')) {
        this.dataAnalysisChart.yAxis = [{
          title: {
            text: '溫度 (°C)'
          },
          opposite: false
        }];
      } else {
        name.forEach(function (x, idx) {
          _this6.dataAnalysisChart.yAxis.push({
            title: {
              text: x
            },
            opposite: idx > 0 ? 1 : false
          });
        });
      }
    },
    getElectricByDays: function getElectricByDays(invArr) {
      var _this7 = this;
      this.chartLegendOptions = ['發電時數 (h)', '發電量 (kWh)', '投資收入 (NTD)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$acp;
        if ((_item$acp = item.acp) !== null && _item$acp !== void 0 && _item$acp.all) {
          _this7.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '發電量 (kWh)') {
                var type = _this7.selectedInvs.length === 0 ? item.acp.all : item.acp.invs[invArr[x] - 1];
                _this7.dataAnalysisChart.series[index].data.push(dbDataHandle(type));
                _this7.rawDataForExcel[index].rawData.push(type);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(type)
              } else if (name[k] === '發電時數 (h)') {
                var _type = _this7.selectedInvs.length === 0 ? item.acp.all / _this7.capacity.reduce(function (a, b) {
                  return a + b;
                }) : item.acp.invs[invArr[x] - 1] / _this7.capacity[invArr[x] - 1];
                _this7.dataAnalysisChart.series[index].data.push(dbDataHandle(_type));
                _this7.rawDataForExcel[index].rawData.push(_type);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(type)
              } else if (name[k] === '投資收入 (NTD)') {
                var _type2 = _this7.selectedInvs.length === 0 ? item.acp.all : item.acp.invs[invArr[x] - 1];
                _this7.dataAnalysisChart.series[index].data.push(dbDataHandle(_type2 * 4.96));
                _this7.rawDataForExcel[index].rawData.push(_type2 * 4.96);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(
                //   type * 4.96
                // )
              }
            }
          }
        }
      });
    },
    getInvTransform: function getInvTransform(invArr) {
      var _this8 = this;
      this.chartLegendOptions = ['轉換效率 (%)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$Eff;
        if ((_item$Eff = item.Eff) !== null && _item$Eff !== void 0 && _item$Eff.all) {
          _this8.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '轉換效率 (%)') {
                if (item.Eff) {
                  var type = _this8.selectedInvs.length === 0 ? item.Eff.all : item.Eff.invs[invArr[x] - 1];
                  _this8.dataAnalysisChart.series[index].data.push(dbDataHandle(type * 100));
                  _this8.rawDataForExcel[index].rawData.push(type * 100);
                  // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(
                  //   type * 100
                  // )
                }
              }
            }
          }
        }
      });
    },
    getAverageIrr: function getAverageIrr(invArr) {
      var _this9 = this;
      this.chartLegendOptions = ['平均日照 (kWh/㎡)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        if (item.IRR) {
          _this9.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '平均日照 (kWh/㎡)') {
                var irrAll = _typeof(item.IRR) === 'object' ? item.IRR.avg : item.IRR;
                _this9.dataAnalysisChart.series[index].data.push(dbDataHandle(irrAll));
                _this9.rawDataForExcel[index].rawData.push(irrAll);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(irrAll)
              }
            }
          }
        }
      });
    },
    getTemp: function getTemp(invArr) {
      var _this10 = this;
      this.chartLegendOptions = ['模組溫度 (°C)', '環境溫度 (°C)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        if (item.PVTemp || item.ENVTemp) {
          _this10.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '模組溫度 (°C)') {
                _this10.dataAnalysisChart.series[index].data.push(dbDataHandle(item.PVTemp));
                _this10.rawDataForExcel[index].rawData.push(item.PVTemp);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(
                //   item.PVTemp
                // )
              } else if (name[k] === '環境溫度 (°C)') {
                _this10.dataAnalysisChart.series[index].data.push(dbDataHandle(item.ENVTemp));
                _this10.rawDataForExcel[index].rawData.push(item.ENVTemp);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(
                //   item.ENVTemp
                // )
              }
            }
          }
        }
      });
    },
    getPR: function getPR(invArr) {
      var _this11 = this;
      this.chartLegendOptions = this.dateCateActive === '時' ? ['等效日照時數 (h)', '發電時數 (h)'] : ['等效日照時數 (h)', '發電時數 (h)', 'PR值 (%)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$acp2;
        if ((_item$acp2 = item.acp) !== null && _item$acp2 !== void 0 && _item$acp2.all) {
          var IRRdata = item.IRR && _typeof(item.IRR) === 'object' ? item.IRR.avg : item.IRR;
          _this11.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '等效日照時數 (h)' && item.IRR) {
                _this11.dataAnalysisChart.series[index].data.push(dbDataHandle(IRRdata));
                _this11.rawDataForExcel[index].rawData.push(IRRdata);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(IRRdata)
              } else if (name[k] === '發電時數 (h)') {
                var type = _this11.selectedInvs.length === 0 ? item.acp.all / _this11.capacity.reduce(function (a, b) {
                  return a + b;
                }) : item.acp.invs[invArr[x] - 1] / _this11.capacity[invArr[x] - 1];
                _this11.dataAnalysisChart.series[index].data.push(dbDataHandle(type));
                _this11.rawDataForExcel[index].rawData.push(type);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(type)
              } else if (name[k] === 'PR值 (%)' && _this11.dateCateActive !== '時' && item.pr) {
                // let PR = this.selectedInvs.length === 0 ? calculatePR(this.capacity, item.acp.all, IRRdata) : dbDataHandle((item.acp.invs[invArr[x] - 1] / this.capacity[invArr[x] - 1] / IRRdata) * 100)
                var PR = _this11.selectedInvs.length === 0 ? item.pr.all * 100 : item.pr.invs[invArr[x] - 1] * 100;
                if (PR >= 100) PR = 100;
                _this11.dataAnalysisChart.series[index].data.push(dbDataHandle(PR, 1));
                _this11.rawDataForExcel[index].rawData.push(PR);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(PR)
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(PR)
              }
            }
          }
        }
      });
    },
    getPeakWatt: function getPeakWatt(invArr) {
      var _this12 = this;
      this.chartLegendOptions = ['峰瓩值 (kWh/kWp)', '發電量 (kWh)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$acp3;
        if ((_item$acp3 = item.acp) !== null && _item$acp3 !== void 0 && _item$acp3.all) {
          _this12.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '峰瓩值 (kWh/kWp)') {
                var PeakWatt = _this12.selectedInvs.length === 0 ? item.acp.all / _this12.capacity.reduce(function (a, b) {
                  return a + b;
                }) : item.acp.invs[invArr[x] - 1] / _this12.capacity[invArr[x] - 1];
                _this12.dataAnalysisChart.series[index].data.push(dbDataHandle(PeakWatt));
                _this12.rawDataForExcel[index].rawData.push(PeakWatt);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(
                //   PeakWatt
                // )
              } else if (name[k] === '發電量 (kWh)') {
                var acp = _this12.selectedInvs.length === 0 ? item.acp.all : item.acp.invs[invArr[x] - 1];
                _this12.dataAnalysisChart.series[index].data.push(dbDataHandle(acp));
                _this12.rawDataForExcel[index].rawData.push(acp);
              }
            }
          }
        }
      });
    },
    getPeakWattHeatmap: function getPeakWattHeatmap(invArr) {
      var _this13 = this;
      this.chartLegendOptions = ['峰瓩值 (kW/kWp)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      var name = this.selectedChartLegends;
      this.heatmapChart.yAxis.categories = [];
      this.heatmapChart.yAxis.categories = invArr[0] === 'ALL' ? ['average'] : invArr.sort(function (a, b) {
        return b - a;
      }).map(function (invNum) {
        return (invNum + '').length === 1 ? "INV0".concat(invNum) : "INV".concat(invNum);
      });

      // 取 06:00 - 17:45
      for (var xAxisTime = 6; xAxisTime <= 17; xAxisTime++) {
        var _this$heatmapChart$xA;
        var pushTimeArr = (xAxisTime + '').length === 1 ? ["0".concat(xAxisTime, ":00"), "0".concat(xAxisTime, ":15"), "0".concat(xAxisTime, ":30"), "0".concat(xAxisTime, ":45")] : ["".concat(xAxisTime, ":00"), "".concat(xAxisTime, ":15"), "".concat(xAxisTime, ":30"), "".concat(xAxisTime, ":45")];
        (_this$heatmapChart$xA = this.heatmapChart.xAxis.categories).push.apply(_this$heatmapChart$xA, pushTimeArr);
      }
      this.heatmapChart.xAxis.categories.forEach(function (time, xAxisIndex) {
        var foundTimeIndex = _this13.analysisAllData.findIndex(function (item) {
          return item.hhmm === time;
        });
        if (foundTimeIndex !== -1) {
          var foundTimeData = _this13.analysisAllData[foundTimeIndex];

          // selectedChartLegends
          for (var k = 0; k < name.length; k++) {
            // select inv 台數
            for (var x = 0; x < invArr.length; x++) {
              // 時間區間 00 15 30 45
              for (var period = 0; period < 4; period++) {
                var PeakWatt = foundTimeData.kWp[period] ? _this13.selectedInvs.length === 0 ? foundTimeData.kWp[period].reduce(function (a, b) {
                  return a + b;
                }) / foundTimeData.kWp[period].length : foundTimeData.kWp[period][invArr[x] - 1] : null;
                _this13.heatmapChart.series[0].data.push([xAxisIndex + period,
                // x 座標
                x,
                // y 座標(inv)
                PeakWatt || PeakWatt === 0 ? Math.round(PeakWatt * 100) / 100 : null // 數值
                ]);
                _this13.rawDataForExcel.push(PeakWatt);
              }
            }
          }
        }
        if (foundTimeIndex === -1 && time.split(':')[1] === '00') {
          for (var _k = 0; _k < name.length; _k++) {
            // select inv 台數
            for (var _x = 0; _x < invArr.length; _x++) {
              for (var _period = 0; _period < 4; _period++) {
                _this13.heatmapChart.series[0].data.push([xAxisIndex + _period, _x, null]);
                _this13.rawDataForExcel.push(null);
              }
            }
          }
        }
      });
    },
    getCo2: function getCo2(invArr) {
      var _this14 = this;
      this.chartLegendOptions = ['二氧化碳排放抑制量 (kg)', '種樹 (棵)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$acp4;
        if ((_item$acp4 = item.acp) !== null && _item$acp4 !== void 0 && _item$acp4.all) {
          _this14.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '二氧化碳排放抑制量 (kg)') {
                var co2 = _this14.selectedInvs.length === 0 ? item.acp.all : item.acp.invs[invArr[x] - 1];
                _this14.dataAnalysisChart.series[index].data.push(dbDataHandle(co2 * 0.495));
                _this14.rawDataForExcel[index].rawData.push(co2 * 0.495);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(co2)
              } else if (name[k] === '種樹 (棵)') {
                var tree = _this14.selectedInvs.length === 0 ? item.acp.all : item.acp.invs[invArr[x] - 1];
                _this14.dataAnalysisChart.series[index].data.push(dbDataHandle(tree * 20));
                _this14.rawDataForExcel[index].rawData.push(tree * 20);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(tree)
              }
            }
          }
        }
      });
    },
    getInvTemp: function getInvTemp(invArr) {
      var _this15 = this;
      this.chartLegendOptions = ['變流器溫度 (°C)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        if (item.temp) {
          _this15.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '變流器溫度 (°C)') {
                var type = _this15.selectedInvs.length === 0 ? item.temp.avg ? item.temp.avg : item.temp : item.temp.invs[invArr[x] - 1] ? item.temp.invs[invArr[x] - 1] : item.temp;
                _this15.dataAnalysisChart.series[index].data.push(dbDataHandle(type));
                _this15.rawDataForExcel[index].rawData.push(type);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(type)
              }
            }
          }
        }
      });
    },
    getInsulation: function getInsulation(invArr) {
      var _this16 = this;
      this.chartLegendOptions = ['平均絕緣阻抗值(MΩ)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        if (item.Insulation) {
          _this16.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '平均絕緣阻抗值(MΩ)') {
                var type = _this16.selectedInvs.length === 0 ? item.Insulation.avg : item.Insulation.invs[invArr[x] - 1];
                _this16.dataAnalysisChart.series[index].data.push(dbDataHandle(type));
                _this16.rawDataForExcel[index].rawData.push(type);
                // this.totalSumArray[name[k]][x][`Inv${invArr[x]}`].push(type)
              }
            }
          }
        }
      });
    },
    getAnemometer: function getAnemometer(invArr) {
      var _this17 = this,
        _this$dataAnalysisCha;
      this.chartLegendOptions = ['平均風速 (m/s)', '瞬間最大陣風 (m/s)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        var _item$anemometer;
        if ((_item$anemometer = item.anemometer) !== null && _item$anemometer !== void 0 && _item$anemometer.avg) {
          _this17.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '平均風速 (m/s)') {
                var _item$anemometer2, _item$anemometer3, _item$anemometer3$avg, _item$anemometer4;
                // 若不是 Array ，其值為 Anemometer1，其他風速計為 null
                var avg = Array.isArray((_item$anemometer2 = item.anemometer) === null || _item$anemometer2 === void 0 ? void 0 : _item$anemometer2.avg) ? (_item$anemometer3 = item.anemometer) === null || _item$anemometer3 === void 0 ? void 0 : (_item$anemometer3$avg = _item$anemometer3.avg) === null || _item$anemometer3$avg === void 0 ? void 0 : _item$anemometer3$avg[invArr[x] - 1] : invArr[x] === 1 ? (_item$anemometer4 = item.anemometer) === null || _item$anemometer4 === void 0 ? void 0 : _item$anemometer4.avg : null;
                _this17.dataAnalysisChart.series[index].data.push(avg ? Math.round(avg * 100) / 100 : null);
                _this17.rawDataForExcel[index].rawData.push(avg);
              } else if (name[k] === '瞬間最大陣風 (m/s)') {
                var _item$anemometer5, _item$anemometer6, _item$anemometer6$max, _item$anemometer7;
                var max = Array.isArray((_item$anemometer5 = item.anemometer) === null || _item$anemometer5 === void 0 ? void 0 : _item$anemometer5.max) ? (_item$anemometer6 = item.anemometer) === null || _item$anemometer6 === void 0 ? void 0 : (_item$anemometer6$max = _item$anemometer6.max) === null || _item$anemometer6$max === void 0 ? void 0 : _item$anemometer6$max[invArr[x] - 1] : invArr[x] === 1 ? (_item$anemometer7 = item.anemometer) === null || _item$anemometer7 === void 0 ? void 0 : _item$anemometer7.max : null;
                _this17.dataAnalysisChart.series[index].data.push(max ? Math.round(max * 100) / 100 : null);
                _this17.rawDataForExcel[index].rawData.push(max);
              }
            }
          }
        }
      });

      // yAxis max
      if ((_this$dataAnalysisCha = this.dataAnalysisChart.series[0]) !== null && _this$dataAnalysisCha !== void 0 && _this$dataAnalysisCha.data.length) {
        name.forEach(function (_, idx) {
          // 各 data 的 max 中取出唯一 max
          _this17.dataAnalysisChart.yAxis[idx].max = Math.max.apply(Math, _toConsumableArray(_this17.dataAnalysisChart.series.map(function (obj) {
            return Math.max.apply(Math, _toConsumableArray(obj.data));
          })));
          _this17.dataAnalysisChart.yAxis[idx].min = 0;
        });
      }
    },
    getAvailability: function getAvailability(invArr) {
      var _this18 = this;
      this.chartLegendOptions = ['妥善率 (%)'];
      if (this.hasChangeActivePageIdx) {
        this.selectedChartLegends = this.chartLegendOptions;
        this.hasChangeActivePageIdx = false;
      }
      this.dataAnalysisChartSeriesPrepare(invArr);
      var name = this.selectedChartLegends;
      this.analysisAllData.forEach(function (item) {
        if (item.availabilityVal) {
          _this18.dataAnalysisChart.xAxis.categories.push(item.hhmm);
          for (var k = 0; k < name.length; k++) {
            for (var x = 0; x < invArr.length; x++) {
              var index = x + k * invArr.length;
              if (name[k] === '妥善率 (%)') {
                // series data
                _this18.dataAnalysisChart.series[index].data.push({
                  y: dbDataHandle(item.availabilityVal),
                  remark: item.remark // 客製 自行放入資料 (data 改用 [{}] 設置)
                });

                // tooltip
                _this18.dataAnalysisChart.tooltip = {
                  formatter: function formatter() {
                    // console.log(this.point)
                    var isRemark = this.point.remark // 取用自行放入的資料
                    ? "<br/>\u5099\u8A3B:<br/>".concat(this.point.remark) : '';
                    return "<span style=\"font-size: 0.8em\">".concat(this.point.category, "</span><br/>") + "<span style=\"color:".concat(this.point.color, "\">\u25CF</span> ") + "".concat(this.series.name, ": <b>").concat(this.point.y, "</b><br/>") + isRemark;
                  }
                };

                // excel
                _this18.rawDataForExcel[index].rawData.push(item.availabilityVal);
              }
            }
          }
        }
      });
    },
    toggleAnemometerAll: function toggleAnemometerAll() {
      this.selectedAnemometers = this.isAnemometerAllSelected ? this.anemometerSelections : [];
    },
    toggleInvAll: function toggleInvAll() {
      this.selectedInvs = this.isInvAllSelected ? this.invSelections : [];
    },
    setInvSelections: function setInvSelections() {
      var invLen = Number(this.$route.query.invLen) || 0;
      this.invSelections = Array.from({
        length: invLen
      }, function (_, i) {
        return "INV".concat(String(i + 1).padStart(2, '0'));
      });
    },
    setAnemometerSelections: function setAnemometerSelections() {
      var anemometerLen = Number(this.$route.query.anemometerLen) || 0;
      this.anemometerSelections = Array.from({
        length: anemometerLen
      }, function (_, i) {
        return "\u98A8\u901F\u8A08".concat(String(i + 1).padStart(2, '0'));
      });
    }
  }),
  watch: {
    selectedInvs: function selectedInvs(newVal, preVal) {
      this.isInvAllSelected = this.selectedInvs.length === this.invSelections.length;
    },
    selectedAnemometers: function selectedAnemometers(newVal, preVal) {
      this.isAnemometerAllSelected = this.selectedAnemometers.length === this.anemometerSelections.length;
    },
    selectedChartLegends: function selectedChartLegends(newVal, preVal) {
      this.analysisAllDataPrepare();
    }
  },
  created: function created() {
    var _this19 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // default YYYY-MM
              if (_this19.hasDataAnalysisTimePermission) {
                _this19.dateCateActive = '時';
                _this19.datePickerFormat = 'YYYY-MM-DD';
              }
              if (_this19.factoryData.length) {
                _context4.next = 4;
                break;
              }
              _context4.next = 4;
              return _this19.asyncLastSingleDoc(_this19.$route.query.siteName);
            case 4:
              _this19.setInvSelections();
              _this19.setAnemometerSelections();
              _this19.confirmSearching();
            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};